










import UnderConstruction from "@/components/UnderConstruction.vue"
import { Vue, Component } from "vue-property-decorator"

@Component({
  name: "Order",
  components: {
    "under-construction": UnderConstruction,
  },
})
export default class Order extends Vue {}
